module.exports = __webpack_public_path__ + "static/media/bronze.387b3fc9.png";